import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=7cb08e4a&scoped=true&"
import script from "./FilterLabel.vue?vue&type=script&lang=ts&"
export * from "./FilterLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=7cb08e4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb08e4a",
  null
  
)

export default component.exports